import { Box, Flex, Placement, Text } from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { CbButton, CbTooltip } from '../..';
import { CbUser } from '../CbUser';
import { ICON_BY_NAME } from '../Icons/Icon';
export interface CbParticipantCardProps {
  hasGroupMeId?: boolean;
  isOddRow?: number;
  notificationsEnabled?: boolean;
  name: string;
  imageUrl: string;
  showNotificationSettings?: boolean;
  handleClick: () => void;
  handlePrimarySelected?: () => void;
}
export const CbParticipantSelectCard: FC<CbParticipantCardProps> = ({
  isOddRow,
  name,
  imageUrl,
  handleClick
}) => {
  return <Box backgroundColor={isOddRow ? 'cloud.100' : 'transparent'} borderRadius={4} height={12} data-sentry-element="Box" data-sentry-component="CbParticipantSelectCard" data-sentry-source-file="CbParticipantCards.tsx">
      <Flex padding={2} justifyContent="space-between" alignItems={'center'} width="100%" data-sentry-element="Flex" data-sentry-source-file="CbParticipantCards.tsx">
        <CbUser name={name} imageUrl={imageUrl} data-sentry-element="CbUser" data-sentry-source-file="CbParticipantCards.tsx" />
        <CbButton aria-label="Clear all participants" background={'none'} _hover={{
        color: 'chonky.700',
        background: 'none',
        border: 'none'
      }} _focus={{
        background: 'none',
        border: 'none'
      }} _active={{
        background: 'none',
        border: 'none'
      }} paddingLeft={6} paddingRight={6} border="none" shadow={'none'} color="chonky.500" height={'30px'} fontSize={'12px'} onClick={handleClick} data-sentry-element="CbButton" data-sentry-source-file="CbParticipantCards.tsx">
          <ICON_BY_NAME.plus color="inherent" width="15px" height="15px" data-sentry-element="unknown" data-sentry-source-file="CbParticipantCards.tsx" />
        </CbButton>
      </Flex>
    </Box>;
};
export const CbParticipantSelectedCard: FC<CbParticipantCardProps> = ({
  hasGroupMeId = false,
  name,
  imageUrl,
  handleClick,
  handlePrimarySelected,
  showNotificationSettings,
  notificationsEnabled
}) => {
  const [toggleNotificationsEnabled, setToggleNotificationsEnabled] = useState(notificationsEnabled);
  useEffect(() => setToggleNotificationsEnabled(notificationsEnabled), [notificationsEnabled]);
  const renderNotificationControl = () => {
    if (!showNotificationSettings) return null;

    // The control might be wrapped in an icon wrapped in a button, or just an icon
    // This is props for a common <Flex> to preserve vertical alignment in the Picker
    const controlContainerProps = {
      justifyContent: 'center',
      width: '30px'
    };
    const iconProps = {
      color: 'chonky.500',
      height: '20px',
      width: '20px'
    };
    const tooltipProps = {
      backgroundColor: 'cloud.800',
      placement: 'bottom' as Placement
    };
    const tooltipTextProps = {
      color: 'white',
      maxWidth: '300px'
    };
    if (!hasGroupMeId) return <CbTooltip {...tooltipProps} content={<Text {...tooltipTextProps}>
              Waiting for learner to connect their GroupMe account.
            </Text>}>
          <Flex {...controlContainerProps}>
            <ICON_BY_NAME.cautiontriangle {...iconProps} color="cloud.300" />
          </Flex>
        </CbTooltip>;
    const NotificationIcon = toggleNotificationsEnabled ? ICON_BY_NAME.alarmbell : ICON_BY_NAME.alarmbelloff;
    return <CbTooltip {...tooltipProps} content={<Text {...tooltipTextProps}>
            {`Notifications involving this learner will ${toggleNotificationsEnabled ? 'be' : 'not be'} sent to this group.`}
          </Text>} data-sentry-element="CbTooltip" data-sentry-component="renderNotificationControl" data-sentry-source-file="CbParticipantCards.tsx">
        <Flex {...controlContainerProps} data-sentry-element="Flex" data-sentry-source-file="CbParticipantCards.tsx">
          <CbButton aria-label="Toggle notifications" background={'none'} _hover={{
          color: 'luigisPants.500',
          background: 'none',
          border: 'none'
        }} _focus={{
          background: 'none',
          border: 'none'
        }} _active={{
          background: 'none',
          border: 'none'
        }} border="none" shadow={'none'} color="cloud.300" height={'30px'} fontSize={'12px'} onClick={() => {
          if (handlePrimarySelected) {
            handlePrimarySelected();
            setToggleNotificationsEnabled(!toggleNotificationsEnabled);
          }
        }} data-sentry-element="CbButton" data-sentry-source-file="CbParticipantCards.tsx">
            <NotificationIcon {...iconProps} data-sentry-element="NotificationIcon" data-sentry-source-file="CbParticipantCards.tsx" />
          </CbButton>
        </Flex>
      </CbTooltip>;
  };
  return <Box borderRadius={4} height={12} data-sentry-element="Box" data-sentry-component="CbParticipantSelectedCard" data-sentry-source-file="CbParticipantCards.tsx">
      <Flex padding={2} justifyContent="space-between" alignItems={'center'} width="100%" data-sentry-element="Flex" data-sentry-source-file="CbParticipantCards.tsx">
        <CbUser name={name} imageUrl={imageUrl} data-sentry-element="CbUser" data-sentry-source-file="CbParticipantCards.tsx" />
        <Flex data-sentry-element="Flex" data-sentry-source-file="CbParticipantCards.tsx">
          {renderNotificationControl()}
          <CbButton aria-label="Remove from selected team members" background={'none'} _hover={{
          color: 'cloud.500',
          background: 'none',
          border: 'none'
        }} _focus={{
          background: 'none',
          border: 'none'
        }} _active={{
          background: 'none',
          border: 'none'
        }} paddingLeft={6} paddingRight={6} border="none" shadow={'none'} color="cloud.300" height={'30px'} fontSize={'12px'} onClick={handleClick} data-sentry-element="CbButton" data-sentry-source-file="CbParticipantCards.tsx">
            <ICON_BY_NAME.closecircle color="inherent" width="15px" height="15px" data-sentry-element="unknown" data-sentry-source-file="CbParticipantCards.tsx" />
          </CbButton>
        </Flex>
      </Flex>
    </Box>;
};